<template lang='pug'>
.popup(:style="closed ? 'display: none' : ''")
  .popup-overlay
  .popup-body
    .popup-body--tooltips
      .popup-headBody--tooltips
        SectionTitle(:sectionText="tips.greeting[0]" :sectionText2="tips.greeting[1]" :styleSmall="true")
        .popup-iconCloseTooltips(@click='close')
          i.icon-sidemenu-close
      .popup-content
        .popup-item
          .popup-tooltips
            img.responsive(:src="getImgURL('/tooltips-' + currentTip + '.jpg')" alt="")
        .popup-item
          .popup-textTooltips
            span.popup-descriptionTooltips {{ tipTexts[currentTip - 1]}}
            .popup-counterTooltips {{ currentTip }} / {{tipLength}}
    .popup-buttons--normal3
      button.popup-button(v-if='currentTip > 1' @click='prev') {{ tips.buttons.previous }}
      button.popup-button.popup-button--active(v-if='currentTip < tipLength' @click='next') {{ tips.buttons.next }}
      button.popup-button.popup-button--active(v-if='currentTip === tipLength' @click='close') {{ tips.buttons.understand }}
</template>
<script>
import SectionTitle from '@/components/modules/section_title/section_title.vue'
import { lockBody, unlockBody, getImgURL } from '@/plugins/tool.js'

export default {
  components: {
    SectionTitle
  },
  props: {
    tips: Object
  },
  data() {
    return {
      currentTip: 1,
      tipLength: this.tips.messages.length,
      tipTexts: this.tips.messages,
      closed: false,
      getImgURL: getImgURL
    }
  },
  created() {
    lockBody()
  },
  methods: {
    next() {
      ++this.currentTip
    },
    prev() {
      --this.currentTip
    },
    close() {
      localStorage.setItem(this.$store.state.storageKeys.visited, true)
      unlockBody()
      this.closed = true
    }
  }
}
</script>
